// Utility functions for vanilla JS
import slideDown from "@/scripts/helpers/slideDown.js";
import slideUp from "@/scripts/helpers/slideUp.js";
import loaded from '@/scripts/helpers/loaded';

loaded(() => {
    document.querySelectorAll('.js--footer__nav--menu').forEach(function(element) {
        element.addEventListener('click', function(e) {
            e.preventDefault();
            var width = window.innerWidth,
                parent = this.closest('.item--footer--navigation__item'),
                content = parent.querySelector('.parent--navigation__item'),
                hasClass = this.classList.contains('active--item');
            if (width < 768) {
                if (!hasClass) {
                    this.classList.add('active--item');
                    slideDown(content);
                } else {
                    this.classList.remove('active--item');
                    slideUp(content);
                }
            }
        });
    });
});
